export const MEETING_STATS_VERSION = '1.0.2';
export const CASE_STATS_VERSION = '1.0.0';
export const CASE_ASSET_VIEW_VERSION = '1.0.0';
export const CASE_SLIDE_STATS_VERSION = '1.0.0';
export const NPS_SCORE_STATS_VERSION = '1.0.0';

/*
CHANGELOG MEETING_STATS_VERSION:

1.0.1:
- casePresentationHistory stores ids instead of indexes
1.0.2
- casePresentationHistory removes all 'null' values and replaces by NULL_ID_VALUE


*/
